import { useUser } from "../../../context/UserContext";
import EventCard from "./components/EventCard";
import Loader from "../../../components/Loader/Loader";
import { useState } from "react";
import AddNewEventForUserButton from "../../../components/AddNewEventForUser/AddNewEventForUserButton";
import AddNewEventForModalForm from "../../../components/AddNewEventForUser/AddNewEventForModalForm";
import PullToRefresh from "react-simple-pull-to-refresh";
import { Link } from "@tanstack/react-router";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useRealtimeUserEvents } from "../../../hooks/useRealtimeData";

export default function UserDashboard() {
  const { user, selectedYear } = useUser();
  const [openNewEvent, setOpenNewEvent] = useState(false);
  
  // Use realtime hook instead of React Query
  const { events: myEvents, loading: isLoading, error } = useRealtimeUserEvents(user?.uid, selectedYear);

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-lg text-red-500">Σφάλμα: {error}</div>
      </div>
    );
  }

  return (
    <PullToRefresh onRefresh={() => Promise.resolve()}>
      <div className="container mx-auto flex flex-col py-4 justify-center">
      <Link
          to="/dashboard"
          className={"p-2 inline-flex items-center gap-2"}
        >
          <ArrowLeftIcon className={"size-5"} /> Πίσω
        </Link>
        <div className="w-full h-full flex flex-col ring-1 rounded-2xl overflow-hidden ring-gray-300 m-2">
          <div className="bg-white text-lg text-gray-900 font-bold px-5 py-2 shadow border-b border-gray-300">
            Οι ομιλίες μου - {myEvents?.length}
          </div>
          <div className="h-full bg-white">
            <table className="w-full">
              <tbody className={""}>
                {myEvents?.length === 0 && (
                  <tr>
                    <td className="text-center text-gray-500 py-10">
                      Δεν έχετε ομιλίες
                    </td>
                  </tr>
                )}

                {myEvents?.map((event, index) => (
                  <EventCard event={event} key={index} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <AddNewEventForUserButton setOpen={setOpenNewEvent} isOne={true} />
        <AddNewEventForModalForm
          open={openNewEvent}
          setOpen={setOpenNewEvent}
        />
      </div>
    </PullToRefresh>
  );
}
